import { getTmsInstance } from "@adeo/tms-lib";
const VALID_CONTEXT_POPOVER_SELECTOR = `[data-selectorid="valid-context-popover"]`;
const VALID_CONTEXT_POPOVER_CONFIRM_SELECTOR = `[data-selectorid="valid-context-popover-cta"]`;
const CHANGE_CONTEXT_POPOVER_SELECTOR = `[data-selectorid="change-context-popover-cta"]`;
const VALID_CONTEXT_POPOVER_CLOSE_SELECTOR = ".mc-popover__close";
const FEATURE_NAME = "autocontext popover selector";
const POPIN_NAME = "autocontext popover";
export function initValidContextPopover() {
  const validContextPopovers = document.querySelectorAll(VALID_CONTEXT_POPOVER_SELECTOR);
  const openContextLayerInSearchModeEvent = new CustomEvent("openStoreContextLayerInSearchMode");
  validContextPopovers.forEach(validContextPopover => {
    var _a, _b, _c, _d;
    const mainStoreName = (_a = validContextPopover.getAttribute("data-main-store-name")) !== null && _a !== void 0 ? _a : "";
    (_b = validContextPopover.querySelector(VALID_CONTEXT_POPOVER_CONFIRM_SELECTOR)) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
      hideValidContextPopover(validContextPopover);
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'yes it is my store',
          'button_value': mainStoreName,
          'feature_name': FEATURE_NAME
        }
      });
    });
    (_c = validContextPopover.querySelector(VALID_CONTEXT_POPOVER_CLOSE_SELECTOR)) === null || _c === void 0 ? void 0 : _c.addEventListener('click', event => {
      event.preventDefault();
      hideValidContextPopover(validContextPopover);
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'Close button',
          'button_value': mainStoreName,
          'feature_name': FEATURE_NAME
        }
      });
    });
    (_d = validContextPopover.querySelector(CHANGE_CONTEXT_POPOVER_SELECTOR)) === null || _d === void 0 ? void 0 : _d.addEventListener('click', () => {
      hideValidContextPopover(validContextPopover);
      window.dispatchEvent(openContextLayerInSearchModeEvent);
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'change my store',
          'button_value': mainStoreName,
          'feature_name': FEATURE_NAME
        }
      });
    });
  });
}
export function showValidContextPopover() {
  document.querySelectorAll(VALID_CONTEXT_POPOVER_SELECTOR).forEach(validContextPopover => {
    const popoverPanel = validContextPopover.querySelector("[popover]");
    if (popoverPanel && !popoverPanel.classList.contains('is-visible')) {
      popoverPanel.classList.add('is-visible');
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'popin.display',
        'event_data': {
          'popin_name': POPIN_NAME,
          'feature_name': 'Popover store selector'
        }
      });
    }
  });
}
function hideValidContextPopover(validContextPopover) {
  const popoverPanel = validContextPopover.querySelector("[popover]");
  popoverPanel === null || popoverPanel === void 0 ? void 0 : popoverPanel.classList.remove('is-visible');
}